'use strict';
import * as $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c from "./internal-9eb04c7a932b923c3bc5eb25fd6219ee930b689c.js";
/** @constructor */
function $c_Lapp_data_AppPushNotificationsState$Denied$() {
}
export { $c_Lapp_data_AppPushNotificationsState$Denied$ as $c_Lapp_data_AppPushNotificationsState$Denied$ };
$c_Lapp_data_AppPushNotificationsState$Denied$.prototype = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$h_O();
$c_Lapp_data_AppPushNotificationsState$Denied$.prototype.constructor = $c_Lapp_data_AppPushNotificationsState$Denied$;
/** @constructor */
function $h_Lapp_data_AppPushNotificationsState$Denied$() {
}
export { $h_Lapp_data_AppPushNotificationsState$Denied$ as $h_Lapp_data_AppPushNotificationsState$Denied$ };
$h_Lapp_data_AppPushNotificationsState$Denied$.prototype = $c_Lapp_data_AppPushNotificationsState$Denied$.prototype;
$c_Lapp_data_AppPushNotificationsState$Denied$.prototype.productIterator__sc_Iterator = (function() {
  return new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_s_Product$$anon$1(this);
});
$c_Lapp_data_AppPushNotificationsState$Denied$.prototype.hashCode__I = (function() {
  return 2043439035;
});
$c_Lapp_data_AppPushNotificationsState$Denied$.prototype.toString__T = (function() {
  return "Denied";
});
$c_Lapp_data_AppPushNotificationsState$Denied$.prototype.productArity__I = (function() {
  return 0;
});
$c_Lapp_data_AppPushNotificationsState$Denied$.prototype.productPrefix__T = (function() {
  return "Denied";
});
$c_Lapp_data_AppPushNotificationsState$Denied$.prototype.productElement__I__O = (function(n) {
  throw $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$ct_jl_IndexOutOfBoundsException__T__(new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_jl_IndexOutOfBoundsException(), ("" + n));
});
$c_Lapp_data_AppPushNotificationsState$Denied$.prototype.productElementName__I__T = (function(n) {
  throw $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$ct_jl_IndexOutOfBoundsException__T__(new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_jl_IndexOutOfBoundsException(), ("" + n));
});
$c_Lapp_data_AppPushNotificationsState$Denied$.prototype.fromProduct__s_Product__O = (function(p) {
  return this;
});
var $d_Lapp_data_AppPushNotificationsState$Denied$ = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$TypeData().initClass($c_Lapp_data_AppPushNotificationsState$Denied$, "app.data.AppPushNotificationsState$Denied$", ({
  Lapp_data_AppPushNotificationsState$Denied$: 1,
  Lapp_data_AppPushNotificationsState: 1,
  s_Equals: 1,
  s_Product: 1,
  Ljava_io_Serializable: 1,
  s_deriving_Mirror: 1,
  s_deriving_Mirror$Product: 1,
  s_deriving_Mirror$Singleton: 1
}));
export { $d_Lapp_data_AppPushNotificationsState$Denied$ as $d_Lapp_data_AppPushNotificationsState$Denied$ };
var $n_Lapp_data_AppPushNotificationsState$Denied$;
function $m_Lapp_data_AppPushNotificationsState$Denied$() {
  if ((!$n_Lapp_data_AppPushNotificationsState$Denied$)) {
    $n_Lapp_data_AppPushNotificationsState$Denied$ = new $c_Lapp_data_AppPushNotificationsState$Denied$();
  }
  return $n_Lapp_data_AppPushNotificationsState$Denied$;
}
export { $m_Lapp_data_AppPushNotificationsState$Denied$ as $m_Lapp_data_AppPushNotificationsState$Denied$ };
//# sourceMappingURL=app.data.-App-Push-Notifications-State$-Denied$.js.map
